import { getOrderItemInsuranceLetterPDF } from 'api/pdf'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { downloadPdf } from 'lib/web/downloadPdf'
import moment from 'moment'
import { getCurrentIntl } from 'i18n/util/currentIntl'

export function getOrderInsuranceLetterFilename(order: App.Order) {
  return `Insurance-Letter-${moment(order.createdAt).format(ISO_DATE_FORMAT)}-${order.bookingNumber}.pdf`
}

export async function downloadCancellationInsuranceLetter(
  order: App.Order,
  item: App.OrderItem | App.OrderBedbankItem,
  offer?: App.HotelOffer,
) {
  const intl = getCurrentIntl()
  try {
    const blob = await getOrderItemInsuranceLetterPDF(order, item, offer)
    const fileName = getOrderInsuranceLetterFilename(order)
    downloadPdf(blob, fileName)
    showSnackbar(
      intl.formatMessage({
        id: 'Vx6ACkxP025yUzX-xgIz',
        defaultMessage: 'Insurance letter has been downloaded successfully.',
        description: 'Snackbar message after successfully downloading an insurance letter',
      }),
      'success',
      {
        heading: intl.formatMessage({
          id: 'cM77ujpzIZlKgweI5maY',
          defaultMessage: 'Download completed',
          description: 'Snackbar heading after successful insurance letter download',
        }),
      },
    )
  } catch {
    showSnackbar(
      intl.formatMessage({
        id: 'hkZDFUoPKCajHQMZEEhh',
        defaultMessage: 'Your insurance letter could not be downloaded. Please contact us for support.',
        description: 'Snackbar error message when insurance letter download fails',
      }),
      'critical',
      {
        heading: intl.formatMessage({
          id: '-7LJOQl2S_38bPyd-pGU',
          defaultMessage: 'Error',
          description: 'Snackbar heading when insurance letter download fails',
        }),
      },
    )
  }
}

export function hasApprovedBNBLRefundRequest(order: App.Order, item: App.OrderItem | App.OrderBedbankItem) {
  const statuses = ['approved_bnbl', 'customer_put_on_hold']
  return statuses.includes(order.refundRequests[item.id]?.status) || statuses.includes(order.refundRequests[item.downgradedFromId ?? '']?.status)
}
